import { NgIf } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-online-training-about',
  standalone: false,
  templateUrl: './online-training-about.component.html',
  styleUrl: './online-training-about.component.scss'
})
export class OnlineTrainingAboutComponent {
  isOpen = false;
  safeYoutubeUrl!: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  openPopup() {
    const videoId = this.extractYoutubeId('https://youtube.com/shorts/L2Y2PUA9HUU?si=UriBXG6nxL1M4gaO');
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    this.safeYoutubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
    this.isOpen = true;
  }

  extractYoutubeId(url: string): string {
    // works for shorts, watch, youtu.be
    const regExp =
      /(?:youtube\.com\/(?:shorts\/|watch\?v=)|youtu\.be\/)([^&?/]+)/;
    const match = url.match(regExp);
    return match ? match[1] : '';
  }

  closePopup(): void {
    this.isOpen = false;
  }
}
